<div class="row" [hidden]="!(isLoaded | async)">
    <div class="col-md-12" id="script-container"></div>
</div>
<div #tplSpinnerIframe [hidden]="isLoaded | async" class="spinner">
    <mat-spinner diameter="50"></mat-spinner>
</div>